import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { MAIN_ROUTES } from 'applications/GSP/shared/constants/router/routePaths';
import { useGetHomePageRoutePath } from 'applications/GSP/shared/hooks/router';
import { useStudent, useUserRole } from 'applications/GSP/shared/hooks/user';
import { UserRole } from 'applications/GSP/shared/types';
import { matchRouteNotStrict } from 'shared/utils/router';

export const useObserveRoute = () => {
  const student = useStudent();
  const role = useUserRole();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const homePageRoutePath = useGetHomePageRoutePath();

  useEffect(() => {
    if (
      MAIN_ROUTES.some(route => matchRouteNotStrict(route)) &&
      !student &&
      (role === UserRole.Staff || role === UserRole.Admin)
    ) {
      navigate(homePageRoutePath);
    }
  }, [pathname, navigate, student, role, homePageRoutePath]);
};
